export const uk = {
    'button-text': 'Ставка'
};
